import { createContext } from 'react';

export const DefaultDatasContext = createContext<{
  panelOpen: boolean;
  setPanelOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  panelVisible?: boolean;
  setPanelVisible?: React.Dispatch<React.SetStateAction<boolean>>;
}>({
  panelOpen: false,
  panelVisible: false,
});
